if($("#contact-form").length>0) {
    $("#contact-form form").validate({
        rules: {
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            email: {
                email: true
            },
            privacy: {
                required: true
            },
        },
        messages: {
            first_name: "Campo obbligatorio",
            last_name: "Campo obbligatorio",
            email: "Campo obbligatorio",
            privacy: "Campo obbligatorio",
        }
    });
}

$(window).scroll(function() {
    if ($(this).scrollTop() > 350) {
        $('.scroll-top').fadeIn();
    }else{
        $('.scroll-top').fadeOut();
    }

    if ($(this).scrollTop() > 50) {
        $('header').addClass('scroll');
    }else{
        $('header').removeClass('scroll');
    }
});


$('.scroll-top').click(function (e) {
    e.preventDefault();
    $("html, body").animate({scrollTop:0}, 'slow');
})
$('.scroll-position').click(function (e) {
    e.preventDefault();
    $("html, body").animate({scrollTop:$('#contact-form').offset().top}, 'slow');
})
$('.slide-cta > .btn-cta').click(function (e) {
    e.preventDefault();
    $("html, body").animate({scrollTop:$('#app').offset().top}, 'slow');
})

$('.hamburger').click(function() {
    $(this).toggleClass("is-active");
    $('.menu').toggleClass("open");
});

if($("#info-msg").length>0) {
    $('#info-msg').show(function () {
        $(".chiudi").click(function(e){
            e.preventDefault();
            $('#info-msg').hide();
            $('.overlay-popup').hide();
        })
    });
}
if($(".faq").length>0) {
    $('.tit-faq').each(function () {
        $(this).click(function () {
            $(this).parent().toggleClass('open');
            if($(this).parent().hasClass('open')){
                $(this).parent().find('.txt-faq').slideDown();
            }else{
                $(this).parent().find('.txt-faq').slideUp();
            }
        })
    })
}

var lastScrollTop = 0;
$(window).scroll(function(event){
    var st = $(this).scrollTop();
    if (st > lastScrollTop){
        $('header').addClass('scrolled');
    } else {
        $('header').removeClass('scrolled');
    }
    lastScrollTop = st;
});
